<template>
    <div class="apprentice-simple-card">
        <div class="error">
            <b-alert
                v-if="hasError"
                variant="danger"
                show>
                {{ $t('slu_dashboard.name_points_cannot_be_longer_than_five_characters') }}
            </b-alert>
        </div>
        <b-form-group
            class="slu-name-module"
            label-for="slu-name-module-input"
            :label="$t('slu_dashboard.name_module')">
            <b-form-input
                id="slu-name-module-input"
                v-model="moduleName"
                placeholder="SLU Dashboard">
            </b-form-input>
        </b-form-group>
        <b-form-group
            class="slu-name-points"
            label-for="slu-name-points-input"
            :label="$t('slu_dashboard.name_points_max_five_characters')">
            <b-form-input
                id="slu-name-points-input"
                v-model="namePoints"
                :placeholder="$t('slu_dashboard.name_points_max_five_characters')"
                maxlength="5">
            </b-form-input>
        </b-form-group>
        <b-form-group
            class="slu-hours-to-points"
            label-for="slu-hours-to-points-input"
            :label="hoursToPointsLabel">
            <b-form-input
                id="slu-hours-to-points-input"
                v-model="hoursToPoints"
                type="number"
                min="0"
                max="200"
                :placeholder="$t('slu_dashboard.amount_of_hours')">
            </b-form-input>
        </b-form-group>
        <b-form-group
            class="sync-with-std-group"
            label-for="slu-stc-switch"
            :label="$t('slu_dashboard.synchronise_with_somtoday')">
            <b-form-checkbox
                class="slu-stc"
                id="slu-stc-switch"
                v-model="sluStc"
                switch>
            </b-form-checkbox>
        </b-form-group>

        <b-button
            class="btn-save btn-primary-icon btn-module-common-settings-store"
            @click="updateSluSchoolSettings">
            {{ $t('common.save') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-slu-dashboard-common-settings-tab-component',
    props: ['sluSchoolSettingsIn'],
    data() {
        return {
            namePoints: this.sluSchoolSettingsIn.name_points,
            hoursToPoints: this.sluSchoolSettingsIn.hours_to_point,
            moduleName: this.sluSchoolSettingsIn.module_name,
            sluStc: !!this.sluSchoolSettingsIn.stc_sync,
            hasError: false,
        };
    },
    computed: {
        hoursToPointsLabel() {
            if (this.namePoints) {
                return this.$t('slu_dashboard.amount_of_hours_in') + this.namePoints;
            } else {
                return this.$t('slu_dashboard.amount_of_hours_in_points');
            }
        },
    },
    methods: {
        updateSluSchoolSettings() {
            this.hasError = false;
            if (this.namePoints.length > 5) {
                this.hasError = true;
                return;
            }

            let data = {
                name_points: this.namePoints,
                hours_to_point: this.hoursToPoints,
                module_name: this.moduleName,
                slu_stc: this.sluStc,
            };
            this.alert.saving();
            axios.post(this.routes.sluSchoolSettings(), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.btn-module-common-settings-store {
    font-size: $base-font-size;
    padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}

.sync-with-std-group ::v-deep {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    label {
        margin-bottom: 0;
    }
}
</style>
